// src/pages/SharedDashboardPage.tsx
/**
 * Shared Dashboard redirect.
 *
 * Handles URLs generated by the "Copy link" action:
 *   Non-project:  /#/Dashboard/:dashboardId/:configValueId
 *   Project:      /#/ProjectDetails/:projectId?ProjectDashboardId=:id&...
 *
 * This component acts as a router that redirects to the correct section so
 * the sidebar highlights the right item. The target page reads the shared
 * dashboard ID from React Router location state.
 *
 * configValueId → target route
 *   1   → /Dashboards          (Dashboards sidebar item)
 *   9   → /Dashboards/9        (Engagements/Projects sidebar item)
 *   15  → /Dashboards/15       (Users sidebar item)
 *   N   → /Dashboards/N        (Card Type sidebar item)
 */

import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

export const SharedDashboardPage: React.FC = () =>
{
  const { dashboardId, configValueId: cvParam } = useParams<{
    dashboardId: string;
    configValueId: string;
  }>();

  const sharedDashboardId = parseInt(dashboardId || '0', 10);
  const configValueId = parseInt(cvParam || '1', 10);

  const targetPath = configValueId === 1 ? '/Dashboards' : `/Dashboards/${configValueId}`;

  return <Navigate to={targetPath} state={{ sharedDashboardId }} replace />;
};

export default SharedDashboardPage;
